// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__10GiR","modalFooterButton":"ModalNotes_modalFooterButton__1gVQ6"};